import { getPath } from "lib";

export const templatesApiSelector = state => state.api.designs.team.templates;
export const isAnyTeamTemplates = state => {
  const templatePages = templatesApiSelector(state).pages;

  // will return true if templates exist in the first page
  return getPath(templatePages, "1.ids.length", 0) >= 1;
};
